import { BALL_ANIMATION_DEFAULT_DURATION_MS } from '../../../../constants/ball.ts';

import { AppSaySoundBaseHandler } from './app-say-sound-base.handler.ts';

/**
 * Handler for app letter pronunciation tasks
 * Used in SoundsIntroduction, Sounds, and SoundsReview tasks
 *
 * This specialized handler focuses on letter sound pronunciation with appropriate ball animation
 */
export class AppPronounceStateChangeHandlerUtil extends AppSaySoundBaseHandler {
  private static _instance: AppPronounceStateChangeHandlerUtil;

  static get instance(): AppPronounceStateChangeHandlerUtil {
    if (!AppPronounceStateChangeHandlerUtil._instance) {
      AppPronounceStateChangeHandlerUtil._instance = new AppPronounceStateChangeHandlerUtil();
    }
    return AppPronounceStateChangeHandlerUtil._instance;
  }

  // Implement abstract methods from base class
  protected getHandlerName(): string {
    return 'AppPronounce';
  }

  protected async playAudio(): Promise<void> {
    // Play the letter sound
    await this.audioPlayerUtil.speakPronunciation();
  }

  protected calculateAnimationDuration(duration: number): number {
    // Use milliseconds for letter pronunciation
    return duration === 0 ? BALL_ANIMATION_DEFAULT_DURATION_MS : duration * 1000;
  }
}

export const getAppPronounceStateChangeHandlerUtil = (): AppPronounceStateChangeHandlerUtil =>
  AppPronounceStateChangeHandlerUtil.instance;
